import { ValueObject } from "@kernel/ddd";
import { Device } from "../device";

export interface ActiveDeviceProps {
  audio: Device | null;
  video: Device | null;
  audioMuted: boolean;
  videoMuted: boolean;
  isScreenSource: boolean; // Flag per identificare source schermo
}

export class ActiveDevice extends ValueObject<ActiveDeviceProps> {
  public clone(): ActiveDevice {
    return new ActiveDevice({
      audio: this.props.audio ? this.props.audio.clone() : null,
      video: this.props.video ? this.props.video.clone() : null,
      audioMuted: this.props.audioMuted,
      videoMuted: this.props.videoMuted,
      isScreenSource: this.props.isScreenSource
    });
  }

  public get audio(): Device | null {
    return this.props.audio;
  }

  public set audio(device: Device | null) {
    this.props.audio = device;
  }

  public get video(): Device | null {
    return this.props.video;
  }

  public set video(device: Device | null) {
    this.props.video = device;
  }

  public get hasAudio(): boolean {
    return this.props.audio !== null;
  }

  public get hasVideo(): boolean {
    return this.props.video !== null;
  }

  public muteAudio(): void {
    this.props.audioMuted = true;
  }

  public unmuteAudio(): void {
    this.props.audioMuted = false;
  }

  public muteVideo(): void {
    this.props.videoMuted = true;
  }

  public unmuteVideo(): void {
    this.props.videoMuted = false;
  }

  public mute(): void {
    this.muteAudio();
    this.muteVideo();
  }

  public unmute(): void {
    this.unmuteAudio();
    this.unmuteVideo();
  }

  public isAudioMuted(): boolean {
    return this.props.audioMuted;
  }

  public isVideoMuted(): boolean {
    return this.props.videoMuted;
  }

  public getProps(): ActiveDeviceProps {
    return this.props;
  }

  public isEmpty(): boolean {
    return this.props.audio === null && this.props.video === null;
  }

  public static create(props: ActiveDeviceProps): ActiveDevice {
    return new ActiveDevice(props);
  }

  public static createEmpty(): ActiveDevice {
    return new ActiveDevice({
      audio: null,
      video: null,
      audioMuted: false,
      videoMuted: false,
      isScreenSource: false
    });
  }

  public get isScreenSource(): boolean {
    return this.props.isScreenSource;
  }

  public setVideoSource(device: Device | null, isScreen: boolean): void {
    this.props.video = device;
    this.props.isScreenSource = isScreen;
  }
}
